/**
 * Given a date string in ISO8601 format, return it in human readable format.
 * @param {string} date - The date string to format.
 * @returns {string} - The formatted date string.
 */
export default function formatDate(date) {
  const dateObject = new Date(date);
  const dateString = dateObject.toLocaleString(
    'en-US',
    {
      dateStyle: 'medium',
      timeStyle: 'long',
    }
  );

  return 'Invalid Date' !== dateString ? dateString : '';
}
